import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import { Link } from 'gatsby';
import { themeGet } from '@styled-system/theme-get';
import { COWSQUARE_APP_URL, ORG_ID } from '../../../constants';
import { AvatarDropdown } from './AvatarDropdown';
import { clickUserOption, getUserOptions } from './userOptions';
import { isBrowser } from '../../../utils/isBrowser';

const Menu = styled.nav`
  display: flex;
  flex-direction: row;
`;

const MenuItem = styled(Link)`
  color: ${themeGet('colors.blacks.6')};
  text-decoration: none;
  font-size: 14px;
  margin-right: 16px;
  height: 60px;
  line-height: 60px;
  letter-spacing: normal;

  &.active {
    color: ${themeGet('colors.blacks.0')};
    font-weight: 600;
    border-bottom: 3px solid ${themeGet('colors.primary')};
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const DesktopMenu = ({ menu = [] }) => (
  <Menu>
    {R.map(item => (
      <MenuItem activeClassName="active" partiallyActive key={item.link} to={item.link}>
        {item.name}
      </MenuItem>
    ))(menu)}
  </Menu>
);

export const DesktopUser = ({ user, avatar }) =>
  isBrowser &&
  (user ? (
    <AvatarDropdown onChange={clickUserOption} user={user} avatar={avatar} options={getUserOptions(user)} />
  ) : (
    <>
      <MenuItem to="/public/apply">Apply</MenuItem>
      <MenuItem
        as="a"
        href={`${COWSQUARE_APP_URL}/user/login?redirect=${encodeURIComponent(
          window.location.href
        )}&orgId=${ORG_ID}`}
      >
        Login
      </MenuItem>
    </>
  ));
